import Vue from 'vue';
import VueRouter from 'vue-router';

const MyDay = () => import('views/MyDay/MyDay.vue');
const Read = () => import('views/Read/Read.vue');
const Movie = () => import('views/Movie/Movie.vue');
const Todo = () => import('views/Todo/Todo.vue');
const New = () => import('views/New/New.vue');

Vue.use(VueRouter);

const routes = [
  {
    // path: '/', //错了
    path: '',
    redirect: 'new',
  },
  {
    path: '/new',
    component: New,
  },
  {
    path: '/myday',
    // name: 'MyDay',
    component: MyDay,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
  },
  {
    path: '/read',
    // name: 'Read',
    component: Read,
  },
  {
    path: '/movie',
    // name: 'Movie',
    component: Movie,
  },
  {
    path: '/todo',
    // name: 'Todo',
    component: Todo,
  },
];

const router = new VueRouter({
  // mode: 'history', //将hash改为history，防止url有#出现
  routes,
});

export default router;
